import { render } from "./workshopView.vue?vue&type=template&id=59e5cddb"
import script from "./workshopView.vue?vue&type=script&lang=js"
export * from "./workshopView.vue?vue&type=script&lang=js"

import "./workshopView.vue?vue&type=style&index=0&id=59e5cddb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__